import { useState } from 'react'
import PropTypes from 'prop-types'
import GridCell from './GridCell'
import React from 'react';

const Grid = ({ boardState, boardSize, cellClicked, style, isClickable}) => {

  const [mouseDown, setMouseDown] = useState(false)

  document.body.onmousedown = () => setMouseDown(true)
  document.body.onmouseup = () => setMouseDown(false)

  // Construct the grid
  var grid = []
  for (let y = 0; y < boardState.length; y++) {
    grid.push([])
    for (let x = 0; x < boardState[y].length; x++) {
      grid[y].push(
        <GridCell
        key={y.toString() + ',' + x.toString()}
        color={(boardState[y][x] === 1 ? 'var(--accent)' : 'var(--accent2)')}
        size={boardSize / boardState.length+.0103}
        cellClicked={() => cellClicked(y, x)}
        mouseDown={mouseDown}
        isClickable={isClickable}
        />)
    }
  }

  return (
    <div style={style}>
      {grid}
    </div>
  )
}

Grid.propTypes = {
  gridState: PropTypes.array,
  cellSize: PropTypes.number,
  cellClicked: PropTypes.func,
  style: PropTypes.object
}

export default Grid